var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timepicker"},[_c('date-picker',{attrs:{"mode":"time","timezone":_vm.timezone,"is24hr":_vm.format24h},on:{"input":_vm.action},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }